import type { IConfEntidades } from '@/modules/Configuracion/interfaces'
import type { IResponseApi } from '@/modules/Core/interfaces'
import { BaseService } from '@/modules/Core/services/BaseService'
import type { AxiosResponse } from 'axios'

export class EntidadService extends BaseService<IConfEntidades> {
  constructor () {
    super({
      baseUrl: 'system/entities/'
    })
  }
  async generateBackup(data: Record<string, unknown>): Promise<AxiosResponse<IResponseApi<string>>> {
    return this.http.post<string>(`/generate-backup-db`, data).catch(this.errorHandle)
  }
  async restoreDb(data: FormData): Promise<AxiosResponse<IResponseApi<string>>> {
    return this.http.post<string>(`/restore-db`, data,{
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).catch(this.errorHandle)
  }
  async updateDevEstructure(data: Record<string, unknown>): Promise<AxiosResponse<IResponseApi<{success:boolean, message:string}>>> {
    return this.http.post<{success:boolean, message:string}>(`/generate-dev-db`, data).catch(this.errorHandle)
  }
  async initDb(data: Record<string, unknown>): Promise<AxiosResponse<IResponseApi<string>>> {
    return this.http.post<string>(`/init-db`, data).catch(this.errorHandle)
  }
}
